export enum AuthModalActionsTypes {
  GO_NEXT = 'GO_NEXT',
  GO_BACK = 'GO_BACK',
  CLOSE_MODAL = 'CLOSE_MODAL',
  TOGGLE_THEME = 'TOGGLE_THEME',
  ENTRY_TYPE = 'ENTRY_TYPE',
}

interface AuthModalGoNextAction {
  type: AuthModalActionsTypes.GO_NEXT;
  currentModal: string;
}

interface ThemeToggleAction {
  type: AuthModalActionsTypes.TOGGLE_THEME;
}


interface AuthModalGoBackAction {
  type: AuthModalActionsTypes.GO_BACK;
  previousModal: string;
}

interface AuthModalCloseAction {
  type: AuthModalActionsTypes.CLOSE_MODAL;
}

interface AuthModalEntryTypeAction {
  type: AuthModalActionsTypes.ENTRY_TYPE;
  entryType: string
}

export function setEntryType(entryType: string): AuthModalEntryTypeAction {
  return {
    type: AuthModalActionsTypes.ENTRY_TYPE,
    entryType,
  }
}

export function ThemeToggleAction(): ThemeToggleAction {
  return {
    type: AuthModalActionsTypes.TOGGLE_THEME,
  };
}

export function setGoNext(currentModal: string): AuthModalGoNextAction {
  return {
    type: AuthModalActionsTypes.GO_NEXT,
    currentModal,
  };
}

export function setGoBack(previousModal: string): AuthModalGoBackAction {
  return {
    type: AuthModalActionsTypes.GO_BACK,
    previousModal,
  };
}

export function setCloseModal(): AuthModalCloseAction {
  return {
    type: AuthModalActionsTypes.CLOSE_MODAL,
  };
}

export type AuthModalActions = AuthModalGoNextAction | AuthModalCloseAction | AuthModalGoBackAction | ThemeToggleAction | AuthModalEntryTypeAction;
